<template>
    <div v-if="!userDataPaymentMethod" class="text-center font-Nunito text-white text-2xl h-32 flex items-center">No Card Added</div>

    <v-card v-else  class="mx-auto !rounded-2xl bg-[url(@/assets/images/fire-wallpaper-1080x1920-30.jpg)] !shadow-none border-0"
        width="360">
        <div class="backdrop-brightness-50 p-4">
            <v-card-title class="pa-0 !justify-between">
                <div></div>
                
                    <Icon :icon="`logos:${userData.pm_type == 'diners' ? 'dinersclub' : userData.pm_type }`" class="text-4xl max-w-[60px] " />
                
                <!-- <span class="title font-medium">Credit Card</span> -->
            </v-card-title>
            <div>
                <Icon icon="flat-color-icons:sim-card-chip" color="#ba9b5b" class="text-5xl" />
            </div>
            <v-card-text class="pa-0 mt-3">
                <div class="text-lg font-semibold mb-2 tracking-widest text-white">**** **** **** {{ userData.pm_last_four }} </div>
                <div class="flex items-center justify-between">
                    <div class="text-xs font-medium grey--text darken-2">
                        <div>
                            CARDHOLDER NAME
                        </div>
                        <div class="text-sm font-medium text-white max-w-[190px] overflow-hidden whitespace-nowrap text-ellipsis">
                          {{ userData.pm_cardholder_name }}
                        </div>
                    </div>
                    <div class="text-xs font-medium grey--text darken-2">
                        <div>
                            EXPIRES
                        </div>
                        <div class="text-sm font-medium text-white"> {{ userData.pm_expiry  }} </div>
                    </div>
                    <div class="text-xs font-medium grey--text darken-2">
                        <div>
                            CVV
                        </div>
                        <div class="text-sm font-medium text-white">***</div>

                    </div>
                </div>

            </v-card-text>
        </div>
    </v-card>
</template>
  
<script>
import { Icon } from '@iconify/vue2';

export default {
    name: "CreditCard",
    components: { Icon },
    computed: {
        
        userData() {
            return this.$store.getters.StateUser.data;
        },
        userDataPaymentMethod() {
            return this.$store.getters.StateUser.data.pm_cardholder_name;
        },
    },
};
</script>
  

  